/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ArCreateRequest,
  ArUpdateRequest,
  AssignmentRuleset,
  CallerRef,
  DraftCreateRequest,
  DraftUpdateRequest,
  MapString,
  MapTypeAssignmentRuleset,
  MapTypeWrappedDraft,
  Order,
  OrderByField,
  PaginatedResultAssignmentRuleset,
  PaginatedResultDraftAndAr,
  QueryAssignmentRulesetRequest,
  UsageRequestRes,
  WrappedDraft,
  WrappedLeaseRes,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "assignment-rulesets";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description attempts to find assignment ruleset specified by id
   *
   * @tags CRUD/AR
   * @name FindAssignmentRuleset
   * @request GET:/v1/tenant/{tenantId}/assignment-ruleset/{assignmentRulesetId}
   * @secure
   */
  findAssignmentRuleset = (
    tenantId: string,
    assignmentRulesetId: string,
    query?: {
      /**
       * if present will attempt to return historical version of assignment ruleset with specified revision - returns deleted resources
       * @format int32
       */
      revision?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AssignmentRuleset,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/assignment-ruleset/${assignmentRulesetId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAssignmentRuleset */
  findAssignmentRulesetPathGetter = (
    tenantId: string,
    assignmentRulesetId: string,
    query?: {
      /**
       * if present will attempt to return historical version of assignment ruleset with specified revision - returns deleted resources
       * @format int32
       */
      revision?: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/assignment-ruleset/${assignmentRulesetId}`, query);

  /**
   * @description update assignment ruleset for the specified revision ONLY
   *
   * @tags CRUD/AR
   * @name UpdateAssignmentRuleset
   * @request PUT:/v1/tenant/{tenantId}/assignment-ruleset/{assignmentRulesetId}
   * @secure
   */
  updateAssignmentRuleset = (
    tenantId: string,
    assignmentRulesetId: string,
    data: ArUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      AssignmentRuleset,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/assignment-ruleset/${assignmentRulesetId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateAssignmentRuleset */
  updateAssignmentRulesetPathGetter = (tenantId: string, assignmentRulesetId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/assignment-ruleset/${assignmentRulesetId}`);

  /**
   * @description deletes assignment ruleset specified by id
   *
   * @tags CRUD/AR
   * @name DeleteAssignmentRuleset
   * @request DELETE:/v1/tenant/{tenantId}/assignment-ruleset/{assignmentRulesetId}
   * @secure
   */
  deleteAssignmentRuleset = (
    tenantId: string,
    assignmentRulesetId: string,
    query?: {
      /**
       * whether rule should be deleted EVEN if there are resources using it
       * @default false
       * @example false
       */
      force?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AssignmentRuleset,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/assignment-ruleset/${assignmentRulesetId}`,
      method: "DELETE",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteAssignmentRuleset */
  deleteAssignmentRulesetPathGetter = (
    tenantId: string,
    assignmentRulesetId: string,
    query?: {
      /**
       * whether rule should be deleted EVEN if there are resources using it
       * @default false
       * @example false
       */
      force?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/assignment-ruleset/${assignmentRulesetId}`, query);

  /**
   * @description query assignment ruleset with provided filters
   *
   * @tags Queries
   * @name QueryAssignmentRulesets
   * @request GET:/v1/tenant/{tenantId}/assignment-ruleset
   * @secure
   */
  queryAssignmentRulesets = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /** @example "asc" */
      order?: Order;
      /** @example "name" */
      orderByField?: OrderByField;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /** @example "Team Pimienta" */
      name?: string;
      /** @example ["a7707826-f4d8-4a41-816c-7d0773718b8a","c5565fce-0c26-4c42-b17e-4abb38f1aaaf"] */
      team?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultAssignmentRuleset,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/assignment-ruleset`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryAssignmentRulesets */
  queryAssignmentRulesetsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /** @example "asc" */
      order?: Order;
      /** @example "name" */
      orderByField?: OrderByField;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /** @example "Team Pimienta" */
      name?: string;
      /** @example ["a7707826-f4d8-4a41-816c-7d0773718b8a","c5565fce-0c26-4c42-b17e-4abb38f1aaaf"] */
      team?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/assignment-ruleset`, query);

  /**
   * @description creates assignment ruleset
   *
   * @tags CRUD/AR
   * @name CreateAssignmentRuleset
   * @request POST:/v1/tenant/{tenantId}/assignment-ruleset
   * @secure
   */
  createAssignmentRuleset = (tenantId: string, data: ArCreateRequest, params: RequestParams = {}) =>
    this.request<
      AssignmentRuleset,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/assignment-ruleset`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createAssignmentRuleset */
  createAssignmentRulesetPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/assignment-ruleset`);

  /**
   * @description attempts to find assignment rulesets specified by ids
   *
   * @tags CRUD/AR
   * @name FindAssignmentRulesetsByIds
   * @request GET:/v1/tenant/{tenantId}/assignment-ruleset-by-ids
   * @secure
   */
  findAssignmentRulesetsByIds = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example ["72100cdd-12fd-471e-8cd2-48ef9dff292a","c011e0a6-6ec2-468d-a3d7-2e1bb6cde220"]
       */
      ids: string[];
      /**
       * if set to `true` request will fail if at least one of the assignment rulesets is missing
       * @default false
       */
      strict?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapTypeAssignmentRuleset,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/assignment-ruleset-by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAssignmentRulesetsByIds */
  findAssignmentRulesetsByIdsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example ["72100cdd-12fd-471e-8cd2-48ef9dff292a","c011e0a6-6ec2-468d-a3d7-2e1bb6cde220"]
       */
      ids: string[];
      /**
       * if set to `true` request will fail if at least one of the assignment rulesets is missing
       * @default false
       */
      strict?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/assignment-ruleset-by-ids`, query);

  /**
   * @description attempts to retrieve assignment rulesets specified by ids and optional revisions
   *
   * @tags CRUD/AR
   * @name RetrieveAssignmentRulesetsIncludingHistoricalData
   * @request POST:/v1/tenant/{tenantId}/assignment-ruleset-by-ids-and-revision
   * @secure
   */
  retrieveAssignmentRulesetsIncludingHistoricalData = (
    tenantId: string,
    data: QueryAssignmentRulesetRequest,
    query?: {
      /**
       * if set to `true` request will fail if at least one of the assignment rulesets is missing
       * @default false
       */
      strict?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AssignmentRuleset[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/assignment-ruleset-by-ids-and-revision`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for retrieveAssignmentRulesetsIncludingHistoricalData */
  retrieveAssignmentRulesetsIncludingHistoricalDataPathGetter = (
    tenantId: string,
    query?: {
      /**
       * if set to `true` request will fail if at least one of the assignment rulesets is missing
       * @default false
       */
      strict?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/assignment-ruleset-by-ids-and-revision`, query);

  /**
   * @description added as a alternative to the usages endpoint with GET method as not every http library support it
   *
   * @tags Lease
   * @name ListResourcesWhichUseThisResource
   * @request PUT:/v1/tenant/{tenantId}/lease
   * @originalName listResourcesWhichUseThisResource
   * @duplicate
   * @secure
   */
  listResourcesWhichUseThisResource = (tenantId: string, data: UsageRequestRes, params: RequestParams = {}) =>
    this.request<
      WrappedLeaseRes[],
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/lease`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listResourcesWhichUseThisResource */
  listResourcesWhichUseThisResourcePathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/lease`);

  /**
   * @description attempts to find assignment ruleset draft specified by the id
   *
   * @tags CRUD/Draft
   * @name FindAssignmentRulesetDraft
   * @request GET:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  findAssignmentRulesetDraft = (tenantId: string, draftId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDraft,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAssignmentRulesetDraft */
  findAssignmentRulesetDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description update assignment ruleset draft for specified revision ONLY
   *
   * @tags CRUD/Draft
   * @name UpdateAssignmentRulesetDraft
   * @request PUT:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  updateAssignmentRulesetDraft = (
    tenantId: string,
    draftId: string,
    data: DraftUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedDraft,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateAssignmentRulesetDraft */
  updateAssignmentRulesetDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description replace assignment ruleset draft specified by the id
   *
   * @tags CRUD/Draft
   * @name ReplaceAssignmentRulesetDraft
   * @request POST:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  replaceAssignmentRulesetDraft = (
    tenantId: string,
    draftId: string,
    data: DraftUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      WrappedDraft,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for replaceAssignmentRulesetDraft */
  replaceAssignmentRulesetDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description deletes assignment ruleset draft specified by the id
   *
   * @tags CRUD/Draft
   * @name DeleteAssignmentRulesetDraft
   * @request DELETE:/v1/tenant/{tenantId}/draft/{draftId}
   * @secure
   */
  deleteAssignmentRulesetDraft = (tenantId: string, draftId: string, params: RequestParams = {}) =>
    this.request<
      WrappedDraft,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft/${draftId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteAssignmentRulesetDraft */
  deleteAssignmentRulesetDraftPathGetter = (tenantId: string, draftId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/draft/${draftId}`);

  /**
   * @description creates assignment ruleset draft
   *
   * @tags CRUD/Draft
   * @name CreateAssignmentRulesetDraft
   * @request POST:/v1/tenant/{tenantId}/draft
   * @secure
   */
  createAssignmentRulesetDraft = (tenantId: string, data: DraftCreateRequest, params: RequestParams = {}) =>
    this.request<
      WrappedDraft,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createAssignmentRulesetDraft */
  createAssignmentRulesetDraftPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/draft`);

  /**
   * @description attempts to find assignment ruleset drafts specified by the ids
   *
   * @tags CRUD/Draft
   * @name FindAssignmentRulesetDraftsByIds
   * @request GET:/v1/tenant/{tenantId}/draft-by-ids
   * @secure
   */
  findAssignmentRulesetDraftsByIds = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example ["72100cdd-12fd-471e-8cd2-48ef9dff292a","c011e0a6-6ec2-468d-a3d7-2e1bb6cde220"]
       */
      ids: string[];
      /**
       * if set to `true` request will fail if at least one of the assignment rulesets is missing
       * @default false
       */
      strict?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapTypeWrappedDraft,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/draft-by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAssignmentRulesetDraftsByIds */
  findAssignmentRulesetDraftsByIdsPathGetter = (
    tenantId: string,
    query: {
      /**
       * @minItems 1
       * @example ["72100cdd-12fd-471e-8cd2-48ef9dff292a","c011e0a6-6ec2-468d-a3d7-2e1bb6cde220"]
       */
      ids: string[];
      /**
       * if set to `true` request will fail if at least one of the assignment rulesets is missing
       * @default false
       */
      strict?: boolean;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/draft-by-ids`, query);

  /**
   * @description query with provided filters - returns matching ars and drafts
   *
   * @tags Queries
   * @name QueryAssignmentRulesetsAndDrafts
   * @request GET:/v1/tenant/{tenantId}/ars-and-drafts
   * @secure
   */
  queryAssignmentRulesetsAndDrafts = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /** @example "asc" */
      order?: Order;
      /** @example "name" */
      orderByField?: OrderByField;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /** @example "Team Pimienta" */
      name?: string;
      /** @example ["a7707826-f4d8-4a41-816c-7d0773718b8a","c5565fce-0c26-4c42-b17e-4abb38f1aaaf"] */
      team?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultDraftAndAr,
      | CallerRef
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/ars-and-drafts`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for queryAssignmentRulesetsAndDrafts */
  queryAssignmentRulesetsAndDraftsPathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
      /** @example "asc" */
      order?: Order;
      /** @example "name" */
      orderByField?: OrderByField;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      createdBy?: CallerRef;
      /**
       * stringified caller reference in format $type/$id
       * @example "user/167a67d47a6da76d4a761"
       */
      updatedBy?: CallerRef;
      /**
       * @pattern [^\s\\/]+
       * @example "a5sd43a5d4a3da5d5ad45ad4asd"
       */
      workspaceId?: string;
      /** @example "Team Pimienta" */
      name?: string;
      /** @example ["a7707826-f4d8-4a41-816c-7d0773718b8a","c5565fce-0c26-4c42-b17e-4abb38f1aaaf"] */
      team?: string[];
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/ars-and-drafts`, query);
}
